






















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Utilities as utils } from "@/shared/utilities";

@Component({
  components: {}
})
export default class CommunicationCardViewComponent extends Vue {
  @Prop() items: Array<any>;
  @Prop() accessRights: any;
}
